import { TranslateFunction } from "@ds/base";

const Errors = (translate: TranslateFunction) => {
    return {
        "protect_api_report_abuse_web_error": translate("Bad Request: try to access the page from the 'Report Abuse' link in the email again."),
        "DEFAULT": translate("Something went wrong, please try again later"),
        "protect_api_report_abuse_token_error": translate("Invalid token in the request. Please refresh the page and try again."),
        "challenge_incomplete": translate("Please solve the challenge on screen and try again."),
        "protect_api_approval_token_expired": translate("Session expired. Please refresh this page and try again.")
    };
};

export default Errors;
